<div>
    <svg [attr.width]="totalWidth" [attr.height]="height" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
        <ng-content></ng-content>
    </svg>
</div>
